import {registerSavedWaypoint} from '@gaia/utils/gaia/saveWaypoint';
import keyBy from 'lodash/keyBy';

export default function (
    action: BulkUpdateAction,
    setWaypoints: React.Dispatch<React.SetStateAction<{[localId: string]: Waypoint}>>
) {
    if (!action.localIds.length) return [];

    setWaypoints((latestWaypoints) => {
        const updatedWaypoints: Waypoint[] = action.updatedWaypoints.map((waypoint) => {
            return {
                type: 'Feature',
                geometry: waypoint.geometry,
                properties: {
                    ...waypoint.properties,
                    localId: waypoint.properties.id,
                    archived: false,
                    isLocallyCreated: false,
                    type: 'waypoint',
                    id: waypoint.properties.id,
                },
            };
        });

        // Updated waypoints that are already local
        const localWaypointIds = action.localIds.filter((id) => latestWaypoints[id]);
        // create empty archived waypoints for the waypoints with localId different than remoteId
        const emptyLocalWaypoints: Waypoint[] = localWaypointIds
            .filter((id) => id !== latestWaypoints[id].properties.id)
            .map((id) => {
                return {
                    type: 'Feature',
                    geometry: {type: 'Point', coordinates: []},
                    properties: {
                        id,
                        archived: true,
                        bulkArchived: true,
                        isLocallyCreated: true,
                        localId: id,
                        title: '',
                        type: 'waypoint',
                    },
                };
            });

        // calling registerSavedWaypoint directly is an escape hatch to prevent the
        // save effect from picking up this change
        emptyLocalWaypoints.forEach((waypoint) => registerSavedWaypoint(waypoint));

        return {
            ...latestWaypoints,
            ...keyBy(updatedWaypoints, (waypoint) => waypoint.properties.id!),
            ...keyBy(emptyLocalWaypoints, (waypoint) => waypoint.properties.id!),
        };
    });

    return action.updatedWaypoints.map((waypoint) => waypoint.properties.id);
}
